<!-- <div class="max-w-7xl mx-auto">
  <h1 class="text-3xl font-bold text-[#0A122A] mb-6">Welcome to Our Website</h1>
  <p class="text-[#0A122A] mb-4">
    This is the main content area of your website. You can add any content here.
  </p>
  <button class="bg-[#698F3F] text-[#FBFAF8] px-4 py-2 rounded hover:opacity-90 transition-opacity">
    Learn More
  </button>
</div> -->

<div class="w-full overflow-hidden">

  <app-hero></app-hero>
  <app-fetured-products></app-fetured-products>
  <app-benifits></app-benifits>
  <app-testimonials></app-testimonials>
  <app-call-to-action></app-call-to-action>

</div>
